define('app/sdc/named/sdc-named',[], function () {
	return {
		transclude: true,
		scope: false
	}
});
